import { BASE_URL } from './BASE_URL';

export const getMPMainText = async () => {
  const response = await fetch(BASE_URL + 'master-plan/text-main-page/');
  const data = await response.json();
  return data;
};
